function getCookie(name) {
  try {
    // Escape special characters in the name for RegExp
    var nameEQ = name.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    var regex = new RegExp("(^| )" + nameEQ + "=([^;]+)");
    var cookie = document.cookie.match(regex);

    // Decode cookie value and trim spaces
    return cookie ? decodeURIComponent(cookie[2].trim()) : "";
  } catch (e) {
    console.error("Error getting cookie:", e);
    return "";
  }
}

const __RHUX_ATTR = {};

const cookiesToGet = [
  "_ga",
  "_gcl_au",
  "_gcl_aw",
  "_ga_RX2VJWWHEH",
  "_shopify_sa_p",
];
for (let i = 0; i < cookiesToGet.length; i++) {
  __RHUX_ATTR[cookiesToGet[i]] = getCookie(cookiesToGet[i]) || "";
}

window.dataLayer = window.dataLayer || [];
window.dataLayer.push({ event: "attr-config", data: __RHUX_ATTR });
